// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6Y3I8","content":"styles_content__XJM0w","row":"styles_row__2Hdsq","footer":"styles_footer__1WtDp","phraseLength":"styles_phraseLength__2roFC"};